import { render, staticRenderFns } from "./AdditionalCourseContents.vue?vue&type=template&id=4ca3ccc1&"
import script from "./AdditionalCourseContents.vue?vue&type=script&lang=js&"
export * from "./AdditionalCourseContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports